import React, { useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import image from "../Images/bg.jpg";
import HttpClient from '../utils/HttpClient';
import toast from 'react-hot-toast';
import NumberCaptchaV2 from "../View/BusinessListing/components/NumberCaptchaV2";
import ResetPasswordSkeleton from "../Component/Skeletons/ResetPasswordSkeleton";
import SeoGeneral from '../View/BusinessPage/SeoGeneral';

const ForgotPassword = () => {

    const navigate = useNavigate()
    const [email, setEmail] = useState("")
    const [formError, setFormError] = useState({
        usernameError: "",
        captchaError: "",
    });
    const captchaRef = useRef();
    const [showLoader, setShowLoader] = useState(false);

    const handleForgetPassword = async () => {
        if (!validateForm()) {
            console.log("Form validation failed.");
            return;
        }
        setShowLoader(true);
        const res = await HttpClient.requestData("forget-password", "POST", { emailId: email });
        if (res && res?.status) {
            navigate('/resetPassword', { state: { email: email } });
        } else {
            toast.error(res?.message)
        }
        setShowLoader(false);
    };

    const validateForm = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email.trim() === "") {
            setFormError((prevState) => ({
                ...prevState,
                usernameError: "email address is required.",
            }));
            isValid = false;
        } else if (!emailRegex.test(email)) {
            setFormError((prevState) => ({
                ...prevState,
                usernameError: "Please enter a valid email address.",
            }));
            isValid = false;
        } else {
            setFormError((prevState) => ({ ...prevState, usernameError: "" }));
        }

        const isNumCaptchValid = captchaRef.current.validate();
        if (!isNumCaptchValid) {
            setFormError((prevState) => ({
                ...prevState,
                captchaError: "Incorrect captcha answer.",
            }));
            isValid = false;
        } else {
            setFormError((prevState) => ({ ...prevState, captchaError: "" }));
        }
        return isValid;
    };

    const seoMetaData = {
        title: "NeooSearch – Forgot Password",
        description: "Reset your NeooSearch account password by entering your email address. We'll send you instructions to securely reset your password and regain access to your account.",
        ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
        ogImageAlt: "NeooSearch – Forgot Password",
        url: process.env.REACT_APP_APPLICATION_URL + "/forgotPassword",
        keywords: "NeooSearch, forgot password, reset password, account recovery, email instructions, secure password reset",
        type: "website",
        site_name: "NeooSearch",
        canonical: process.env.REACT_APP_APPLICATION_URL + "/forgotPassword"
    };

    return (
        <>
            <SeoGeneral data={seoMetaData} />
            <section className="authenSec">
                <div className="authenSecInn">
                    <div className="container">
                        <div className="authenSecInnDiv">
                            <div className="authenSecForm">
                                <div className="authenSecTop">
                                    <div className='forgetFig'>
                                    </div>
                                    <h4>Reset Password</h4>
                                    <p>Enter your email address below, and we'll send you instructions to reset your password.</p>
                                </div>

                                <div className="authenSecBtm">
                                    {showLoader ? (<ResetPasswordSkeleton />) : (
                                        <form>
                                            <div className="form-group">
                                                <input type="email" placeholder='Email Id'
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    required={true}
                                                />
                                                {formError.usernameError && (
                                                    <p
                                                        className="error-message"
                                                        style={{
                                                            color: "red",
                                                            fontSize: "12px",
                                                        }}
                                                    >
                                                        {formError.usernameError}
                                                    </p>
                                                )}
                                            </div>
                                            <div className='form-group'>
                                                <div className="addedasldibv">
                                                    <NumberCaptchaV2 ref={captchaRef} />
                                                </div>

                                                {formError.captchaError && (
                                                    <p
                                                        className="error-message"
                                                        style={{
                                                            color: "red",
                                                            fontSize: "12px",
                                                        }}
                                                    >
                                                        {formError.captchaError}
                                                    </p>
                                                )}
                                            </div>
                                            <button type='button' className='homeloginBtn'
                                                onClick={handleForgetPassword}
                                            >Send</button>
                                        </form>
                                    )}
                                </div>

                            </div>
                            <div className="authenSecImg">
                                <img src={image} alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ForgotPassword